(function(window, document){
  'use strict';

  function normalize(value){
    return String(value || '').trim().toLowerCase();
  }

  function getStorage(key){
    try {
      return window.localStorage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function setStorage(key, value){
    try {
      if(value === undefined || value === null || value === '') window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, String(value));
    } catch (error) {}
  }

  function getKitBuilderStorageKey(handle, colourway, sectionId){
    var cleanHandle = String(handle || '').trim();
    var cleanColourway = String(colourway || '').trim();
    var cleanSection = String(sectionId || '').trim();
    if(!cleanHandle || !cleanColourway || !cleanSection) return '';
    return 'msh_kb_svg_v1_' + cleanSection + '::' + cleanHandle + '::' + cleanColourway;
  }

  function readKitBuilderState(handle, colourway){
    var cleanHandle = String(handle || '').trim();
    var cleanColourway = String(colourway || '').trim();
    if(!cleanHandle || !cleanColourway) return null;

    var prefix = 'msh_kb_svg_v1_';
    var suffix = '::' + cleanHandle + '::' + cleanColourway;
    var fallbackSuffix = '::' + cleanHandle + '::';
    var fallbackRaw = '';

    try {
      for(var idx = 0; idx < window.localStorage.length; idx++){
        var key = window.localStorage.key(idx);
        if(!key || key.indexOf(prefix) !== 0) continue;

        if(key.slice(-suffix.length) === suffix){
          var exactRaw = window.localStorage.getItem(key);
          if(!exactRaw) continue;
          var exactParsed = JSON.parse(exactRaw);
          if(exactParsed && typeof exactParsed === 'object'){
            exactParsed.__storageKey = key;
            return exactParsed;
          }
          continue;
        }

        if(!fallbackRaw && key.slice(-fallbackSuffix.length) === fallbackSuffix){
          fallbackRaw = window.localStorage.getItem(key) || '';
        }
      }

      if(fallbackRaw){
        var fallbackParsed = JSON.parse(fallbackRaw);
        if(fallbackParsed && typeof fallbackParsed === 'object') return fallbackParsed;
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function readKitBuilderBadgeData(handle, colourway){
    var parsed = readKitBuilderState(handle, colourway);
    if(parsed && typeof parsed.badgeData === 'string' && parsed.badgeData) return parsed.badgeData;
    return '';
  }

  function dispatchKitBuilderUpdated(){
    try {
      window.dispatchEvent(new CustomEvent('msh:kitbuilder:updated'));
    } catch (error) {
      try {
        var fallbackEvent = document.createEvent('Event');
        fallbackEvent.initEvent('msh:kitbuilder:updated', true, true);
        window.dispatchEvent(fallbackEvent);
      } catch (innerError) {}
    }
  }

  function readBuilderBlobField(fieldName){
    var cleanField = String(fieldName || '').trim();
    if(!cleanField) return '';

    try {
      for(var idx = 0; idx < window.localStorage.length; idx += 1){
        var key = window.localStorage.key(idx);
        if(!key || key.indexOf('msh_kb_svg_v1_') !== 0) continue;
        var raw = window.localStorage.getItem(key) || '';
        if(!raw) continue;
        var parsed = JSON.parse(raw);
        if(parsed && typeof parsed === 'object' && parsed[cleanField]) return parsed[cleanField];
      }
    } catch (error) {}

    return '';
  }

  function hasStoredAsset(primaryKey, fallbackKey, blobField){
    var direct = getStorage(primaryKey) || getStorage(fallbackKey);
    if(direct) return true;
    return !!readBuilderBlobField(blobField);
  }

  function syncPersonalisationIncludedFlags(){
    var badgeIncluded = hasStoredAsset('mshBadgeDataUrl', 'mshBadgeData', 'badgeData') ? 'Yes' : 'No';
    var sponsorIncluded = hasStoredAsset('mshSponsorDataUrl', 'mshSponsorData', 'sponsorData') ? 'Yes' : 'No';
    setStorage('mshBadgeIncluded', badgeIncluded);
    setStorage('mshSponsorIncluded', sponsorIncluded);
    dispatchKitBuilderUpdated();
  }

  function bindPersonalisationIncludedFlagSync(){
    var root = document.querySelector('[data-msh-kb]') || document;
    if(!root) return;

    root.addEventListener('change', function(event){
      var target = event.target;
      if(!target || !target.matches) return;
      if(target.matches('[data-kb-badge], [data-kb-sponsor]')) syncPersonalisationIncludedFlags();
    }, true);

    root.addEventListener('click', function(event){
      var target = event.target;
      if(!target || !target.closest) return;
      if(target.closest('[data-kb-clear], [data-kb-tool="badge"], [data-kb-tool="sponsor"]')){
        window.requestAnimationFrame(syncPersonalisationIncludedFlags);
      }
    }, true);

    window.addEventListener('storage', function(event){
      if(!event || !event.key) return;
      if(
        event.key === 'mshBadgeData' ||
        event.key === 'mshBadgeDataUrl' ||
        event.key === 'mshSponsorData' ||
        event.key === 'mshSponsorDataUrl' ||
        event.key.indexOf('msh_kb_svg_v1_') === 0
      ){
        syncPersonalisationIncludedFlags();
      }
    });

    syncPersonalisationIncludedFlags();
  }

  function getQueryParams(){
    try {
      return new URLSearchParams(window.location.search || '');
    } catch (error) {
      return new URLSearchParams('');
    }
  }

  function getQueryParam(key){
    return getQueryParams().get(key) || '';
  }

  function setQueryParam(key, value, options){
    var params = getQueryParams();
    if(value === undefined || value === null || value === '') params.delete(key);
    else params.set(key, value);

    var next = window.location.pathname + (params.toString() ? ('?' + params.toString()) : '');
    if(options && options.replace) window.history.replaceState({}, '', next);
    else window.history.pushState({}, '', next);
  }

  function normalizeView(raw){
    var value = normalize(raw).replace(/\s+/g, '');
    if(value === 'main' || value === 'front' || value === 'f') return 'front';
    if(value === 'back' || value === 'b') return 'back';
    return 'front';
  }

  function parseColourwayAlt(altRaw){
    var raw = String(altRaw || '').trim();
    if(!raw) return null;

    var parts = raw.split('|').map(function(part){
      return String(part || '').trim();
    });

    var model = parts[0] || '';
    var colourName = parts[1] || '';

    if(!model || !colourName) return null;

    return {
      model: model,
      modelNorm: normalize(model),
      colourName: colourName,
      colourNorm: normalize(colourName),
      side: normalizeView(parts[2]),
      raw: raw
    };
  }

  function buildColourwaysFromMedia(media, modelNamespace){
    var list = Array.isArray(media) ? media : [];
    var grouped = {};
    var namespaceNorm = normalize(modelNamespace || '');

    for(var i = 0; i < list.length; i++){
      var item = list[i] || {};
      var parsed = parseColourwayAlt(item.alt);
      var src = item.src || (item.preview_image && item.preview_image.src) || '';
      if(!parsed || !src) continue;
      if(namespaceNorm && parsed.modelNorm !== namespaceNorm) continue;

      var key = parsed.modelNorm + '::' + parsed.colourNorm;
      if(!grouped[key]){
        grouped[key] = {
          name: parsed.colourName,
          frontSrc: '',
          backSrc: '',
          anySrc: ''
        };
      }

      if(!grouped[key].anySrc) grouped[key].anySrc = src;
      if(parsed.side === 'front' && !grouped[key].frontSrc) grouped[key].frontSrc = src;
      if(parsed.side === 'back' && !grouped[key].backSrc) grouped[key].backSrc = src;
    }

    return Object.keys(grouped).sort(function(a, b){
      return grouped[a].name.localeCompare(grouped[b].name);
    }).map(function(key){
      var row = grouped[key];
      var preferred = row.frontSrc || row.anySrc || row.backSrc;
      return {
        name: row.name,
        frontSrc: row.frontSrc || preferred || '',
        backSrc: row.backSrc || preferred || '',
        anySrc: row.anySrc || preferred || ''
      };
    }).filter(function(row){
      return row.anySrc || row.frontSrc || row.backSrc;
    });
  }

  function fetchKbProductData(handle){
    var clean = String(handle || '').trim();
    if(!clean) return Promise.reject(new Error('Missing handle'));

    return fetch('/products/' + encodeURIComponent(clean) + '?view=kb-product-data', {
      credentials: 'same-origin'
    }).then(function(response){
      if(!response.ok) throw new Error('Failed to load product data for ' + clean);
      return response.json();
    });
  }

  function escapeHtml(value){
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function readProducts(root){
    var dataEl = root.querySelector('[data-products-json]');
    if(!dataEl) return [];

    try {
      var parsed = JSON.parse(dataEl.textContent || '[]');
      if(!Array.isArray(parsed)) return [];
      return parsed.filter(function(item){
        return item && item.handle;
      });
    } catch (error) {
      return [];
    }
  }

  function setButtonEnabled(button, enabled){
    if(!button) return;
    button.disabled = !enabled;
    button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
  }


  function keepQueryParam(params, source, key){
    var value = source.get(key) || '';
    if(value) params.set(key, value);
  }

  function normalizeBand(raw){
    var value = normalize(raw);
    if(value === 'jnr' || value === 'junior' || value === 'youth' || value === 'kid' || value === 'kids') return 'jnr';
    return 'snr';
  }

  function getSelectedBand(params){
    var sourceParams = params || getQueryParams();
    var urlBand = normalize(sourceParams.get('band') || '');
    var lsBand = normalize(
      getStorage('mshAgeBand') ||
      getStorage('msh_audience') ||
      getStorage('mshBand') ||
      ''
    );

    var band = (urlBand === 'jnr' || urlBand === 'snr') ? urlBand : ((lsBand === 'jnr' || lsBand === 'snr') ? lsBand : 'snr');

    if(urlBand === 'jnr' || urlBand === 'snr'){
      setStorage('mshAgeBand', urlBand);
      setStorage('msh_audience', urlBand);
      setStorage('mshBand', urlBand);
    }

    return band;
  }

  function getPreferredShirtHandle(params){
    var queryHandle = params.get('handle') || '';
    if(queryHandle) return queryHandle;

    var storageKeys = ['mshModelHandle', 'msh_last_model', 'mshShirtHandle', 'mshJerseyHandle', 'mshSelectedShirtHandle', 'mshKitBuilderHandle'];
    for(var i = 0; i < storageKeys.length; i++){
      var stored = getStorage(storageKeys[i]);
      if(stored) return stored;
    }

    return '';
  }

  function ensureCanonicalShirtHandle(){
    var params = getQueryParams();
    var handle = getPreferredShirtHandle(params);
    if(!handle) return '';

    setStorage('mshModelHandle', handle);
    setStorage('mshShirtHandle', handle);
    setStorage('msh_last_model', handle);

    try {
      if(params.get('kbdebug') === '1' && window.Shopify && window.Shopify.designMode){
        console.log(
          '[MSHKBFlow] canonical shirt handle:',
          handle,
          'mshModelHandle=',
          window.localStorage.getItem('mshModelHandle'),
          'mshShirtHandle=',
          window.localStorage.getItem('mshShirtHandle')
        );
      }
    } catch (error) {}

    return handle;
  }

  function buildStepUrl(step){
    var stepName = normalize(step);
    var pathMap = {
      shirt: '/pages/kit-builder',
      shorts: '/pages/kit-shorts',
      socks: '/pages/kit-socks',
      review: '/pages/kit-brochure'
    };

    var targetPath = pathMap[stepName] || '/';
    var currentParams = new URLSearchParams(location.search);
    var nextParams = new URLSearchParams('');

    var band = getSelectedBand(currentParams);
    if(!nextParams.get('band')) nextParams.set('band', band);
    keepQueryParam(nextParams, currentParams, 'kit');

    if(stepName === 'shirt'){
      var shirtHandle = getStorage('mshModelHandle') || getStorage('mshShirtHandle') || getPreferredShirtHandle(currentParams);
      var shirtColourway = getStorage('mshColourway') || getStorage('mshShirtColourway') || '';
      if(shirtHandle) nextParams.set('handle', shirtHandle);
      if(shirtColourway) nextParams.set('colourway', shirtColourway);
    }

    if(stepName === 'shorts'){
      var shortsHandle = getStorage('mshShortsHandle') || '';
      var shortsColourway = getStorage('mshShortsColourway') || '';
      if(shortsHandle) nextParams.set('handle', shortsHandle);
      if(shortsColourway) nextParams.set('colourway', shortsColourway);
    }

    if(stepName === 'socks'){
      var socksHandle = getStorage('mshSocksHandle') || '';
      var socksColourway = getStorage('mshSocksColourway') || '';
      if(socksHandle) nextParams.set('handle', socksHandle);
      if(socksColourway) nextParams.set('colourway', socksColourway);
    }

    if(stepName === 'review'){
      nextParams.delete('handle');
      nextParams.delete('colourway');
    }

    var query = nextParams.toString();
    return targetPath + (query ? ('?' + query) : '');
  }

  function wireProgressLinks(root){
    root.querySelectorAll('[data-kb-step-link]').forEach(function(link){
      var step = link.getAttribute('data-kb-step') || '';
      var href = buildStepUrl(step);
      if(href) link.setAttribute('href', href);
    });
  }

  function initKbModelPicker(config){
    var cfg = config || {};
    var root = cfg.root;
    if(typeof root === 'string') root = document.querySelector(root);
    if(!root) return;

    var modelGrid = root.querySelector('[data-kb-model-grid]');
    var modal = root.querySelector('[data-kb-overlay]');
    var closeButtons = root.querySelectorAll('[data-kb-close-overlay]');
    var overlayTitle = root.querySelector('[data-kb-overlay-title]');
    var preview = root.querySelector('[data-kb-preview-image]');
    var tilesGrid = root.querySelector('[data-kb-colourway-grid]');
    var noColourways = root.querySelector('[data-kb-no-colourways]');
    var continueBtn = root.querySelector('[data-kb-continue]');
    var footerLabel = root.querySelector('[data-kb-footer-label]');

    if(!modelGrid || !modal || !tilesGrid || !preview || !continueBtn) return;

    wireProgressLinks(root);

    var products = readProducts(root);
    var dataCache = {};

    var activeHandle = '';
    var activeProduct = null;
    var activeColourways = [];
    var activeColourwayName = '';

    var defaultNext = cfg.nextUrl || '/';

    function getProductByHandle(handle){
      var wanted = normalize(handle);
      for(var i = 0; i < products.length; i++){
        if(normalize(products[i].handle) === wanted) return products[i];
      }
      return null;
    }

    function getColourway(name){
      var wanted = normalize(name);
      for(var i = 0; i < activeColourways.length; i++){
        if(normalize(activeColourways[i].name) === wanted) return activeColourways[i];
      }
      return null;
    }

    function setBodyScrollLock(locked){
      document.documentElement.classList.toggle('msh-kb-lock-scroll', locked);
      document.body.classList.toggle('msh-kb-lock-scroll', locked);
    }

    function renderModelCards(){
      var params = new URLSearchParams(location.search);
      var band = getSelectedBand(params);

      modelGrid.innerHTML = products.map(function(product){
        var featured = product.featured ? (
          '<img class="msh-kb__model-image" src="' + escapeHtml(product.featured) + '" alt="' + escapeHtml(product.title || product.handle) + '" loading="lazy">'
        ) : '<span class="msh-kb__model-image msh-kb__model-image--placeholder" aria-hidden="true"></span>';
        var p = (band === 'jnr') ? product.price_jnr : product.price_snr;
        var n = null;
        if(typeof p === 'string' && p.trim()) n = parseFloat(p);
        else if(typeof p === 'number') n = p;
        if(!isFinite(n)) n = null;
        if(n == null){
          if(typeof product.shopify_price_cents === 'number' && product.shopify_price_cents > 0) n = product.shopify_price_cents / 100;
        }
        var priceHtml = '';
        if(n != null){
          priceHtml = '<div class="mshM-price"><span class="msh-from">From £' + escapeHtml(n.toFixed(2)) + '</span></div>';
        }

        return (
          '<button type="button" class="msh-kb__model-card" data-kb-model-handle="' + escapeHtml(product.handle) + '">' +
            '<span class="msh-kb__model-image-wrap">' + featured + '</span>' +
            '<span class="msh-kb__model-meta">' +
              '<strong class="msh-kb__model-title">' + escapeHtml(product.title || product.handle) + '</strong>' +
              priceHtml +
              '<span class="msh-kb__model-sub">Choose colourway</span>' +
            '</span>' +
          '</button>'
        );
      }).join('');

      modelGrid.querySelectorAll('[data-kb-model-handle]').forEach(function(button){
        button.addEventListener('click', function(){
          var handle = button.getAttribute('data-kb-model-handle') || '';
          openOverlay(handle);
        });
      });
    }

    function renderColourwayTiles(){
      if(!activeColourways.length){
        tilesGrid.innerHTML = '';
        if(noColourways) noColourways.hidden = false;
        setButtonEnabled(continueBtn, false);
        return;
      }

      if(noColourways) noColourways.hidden = true;
      tilesGrid.innerHTML = activeColourways.map(function(item){
        var active = normalize(item.name) === normalize(activeColourwayName);
        var tileImage = item.frontSrc || item.anySrc || item.backSrc || (activeProduct && activeProduct.featured) || '';
        return (
          '<button type="button" class="msh-kb__colourway-tile' + (active ? ' is-active' : '') + '" data-kb-colourway="' + escapeHtml(item.name) + '">' +
            '<span class="msh-kb__colourway-thumb-wrap">' +
              '<img class="msh-kb__colourway-thumb" src="' + escapeHtml(tileImage) + '" alt="' + escapeHtml(item.name) + '" loading="lazy">' +
            '</span>' +
            '<span class="msh-kb__colourway-name">' + escapeHtml(item.name) + '</span>' +
          '</button>'
        );
      }).join('');

      tilesGrid.querySelectorAll('[data-kb-colourway]').forEach(function(tile){
        tile.addEventListener('click', function(){
          selectColourway(tile.getAttribute('data-kb-colourway') || '');
        });
      });
    }

    function updatePreview(colourway){
      var imageSrc = '';
      if(colourway) imageSrc = colourway.frontSrc || colourway.anySrc || colourway.backSrc;
      if(!imageSrc && activeProduct) imageSrc = activeProduct.featured || '';

      preview.src = imageSrc;
      preview.alt = activeProduct ? (activeProduct.title + (colourway ? (' — ' + colourway.name) : '')) : 'Selected colourway preview';
    }

    function syncState(){
      if(cfg.storageHandleKey) setStorage(cfg.storageHandleKey, activeHandle);
      if(cfg.storageColourwayKey) setStorage(cfg.storageColourwayKey, activeColourwayName);
      setQueryParam('handle', activeHandle, { replace: true });
      setQueryParam('colourway', activeColourwayName, { replace: true });
    }

    function selectColourway(name){
      var selected = getColourway(name);
      if(!selected) return;

      activeColourwayName = selected.name;
      updatePreview(selected);
      renderColourwayTiles();
      setButtonEnabled(continueBtn, true);
      syncState();
    }

    function getProductData(handle){
      if(dataCache[handle]) return Promise.resolve(dataCache[handle]);
      return fetchKbProductData(handle).then(function(data){
        dataCache[handle] = data || {};
        return dataCache[handle];
      });
    }

    function openModalShell(){
      modal.hidden = false;
      root.classList.add('is-overlay-open');
      setBodyScrollLock(true);
    }

    function closeOverlay(){
      modal.hidden = true;
      root.classList.remove('is-overlay-open');
      setBodyScrollLock(false);
    }

    function openOverlay(handle){
      var product = getProductByHandle(handle);
      if(!product) return;

      activeHandle = product.handle;
      activeProduct = product;
      activeColourways = [];
      activeColourwayName = '';

      if(overlayTitle) overlayTitle.textContent = (product.title || product.handle) + ' colourways';
      if(footerLabel) footerLabel.textContent = cfg.stepTitle || '';
      tilesGrid.innerHTML = '<p class="msh-kb__loading">Loading colourways…</p>';
      if(noColourways) noColourways.hidden = true;
      setButtonEnabled(continueBtn, false);
      updatePreview(null);

      openModalShell();
      syncState();

      getProductData(product.handle).then(function(data){
        if(activeHandle !== product.handle) return;

        activeColourways = buildColourwaysFromMedia((data && data.media) || [], '');
        renderColourwayTiles();

        if(!activeColourways.length){
          syncState();
          return;
        }

        var rememberedColourway = cfg.storageColourwayKey ? getStorage(cfg.storageColourwayKey) : '';
        var urlColourway = getQueryParam('colourway');
        var preselect = getColourway(rememberedColourway) || getColourway(urlColourway);
        if(preselect) selectColourway(preselect.name);
      }).catch(function(){
        activeColourways = [];
        renderColourwayTiles();
        syncState();
      });
    }

    function continueFlow(){
      if(!activeHandle || !activeColourwayName) return;
      var params = new URLSearchParams(location.search);
      var band = getSelectedBand(params);
      var kit = params.get('kit') || '';
      var url = new URL(defaultNext, window.location.origin);
      if(band) url.searchParams.set('band', band);
      if(kit) url.searchParams.set('kit', kit);
      window.location.href = url.pathname + (url.search ? url.search : '');
    }

    closeButtons.forEach(function(button){
      button.addEventListener('click', closeOverlay);
    });

    modal.addEventListener('click', function(event){
      if(event.target === modal) closeOverlay();
    });

    document.addEventListener('keydown', function(event){
      if(event.key === 'Escape' && !modal.hidden) closeOverlay();
    });

    continueBtn.addEventListener('click', continueFlow);

    var shouldAutoPick = getQueryParam('autopick') === '1';
    if(shouldAutoPick){
      var queryHandle = getQueryParam('handle');
      var storedHandle = cfg.storageHandleKey ? getStorage(cfg.storageHandleKey) : '';
      var initialHandle = queryHandle || storedHandle;
      if(initialHandle && getProductByHandle(initialHandle)) openOverlay(initialHandle);
    }

    renderModelCards();
  }

  ensureCanonicalShirtHandle();
  bindPersonalisationIncludedFlagSync();

  window.MSHKBFlow = {
    normalize: normalize,
    getStorage: getStorage,
    setStorage: setStorage,
    getKitBuilderStorageKey: getKitBuilderStorageKey,
    readKitBuilderState: readKitBuilderState,
    readKitBuilderBadgeData: readKitBuilderBadgeData,
    getQueryParam: getQueryParam,
    setQueryParam: setQueryParam,
    normalizeView: normalizeView,
    parseColourwayAlt: parseColourwayAlt,
    buildColourwaysFromMedia: buildColourwaysFromMedia,
    fetchKbProductData: fetchKbProductData,
    buildStepUrl: buildStepUrl,
    initKbModelPicker: initKbModelPicker,
    initKbPicker: initKbModelPicker
  };
})(window, document);
